export const STOCK_COUNT_DOCUMENT_DROP_DOWN_ITEMS = [
    {
        id: "stock-counts",
        text: "stock count"
    },
]